<script>
import Blocker from '@/vcs/_shared/blocker/Blocker.vue'
import RemoteControlBlocker from '@/vcs/_shared/blocker/RemoteControlBlocker.vue'
import ReconnectBlocker from '@/vcs/_shared/blocker/ReconnectBlocker.vue'
import RemoteControlBar from '@/vcs/_shared/session/RemoteControlBar.vue'
import TimeoutAlert from '@/vcs/_shared/timeout-alert/TimeoutAlert.vue'
import ModalRoot from '@/vcs/_shared/modals/modal-root/ModalRoot.vue'
import ToastRoot from '@/vcs/_shared/toast-root/ToastRoot.vue'
import RootSocketListener from '@/vcs/_shared/RootSocketListener.vue'
import { mapGetters } from 'vuex'

export default {
  components: {
    Blocker,
    TimeoutAlert,
    ReconnectBlocker,
    ModalRoot,
    ToastRoot,
    RemoteControlBlocker,
    RemoteControlBar,
    RootSocketListener
  },
  computed: {
    ...mapGetters({
      uiBlocked: 'getBlockerStatus',
      uiBlockedByReconnect: 'getReconnectBlockerStatus',
      timeoutAlertVisible: 'getSessionTimerStatus',
      userToken: 'getUserToken',
      fingerprint: 'getFingerprint',
      slideUp: 'getSlideUpStatus'
    })
  },
  created() {
    this.determineLocales()
    this.addOnlineEventListener()
  },
  methods: {
    detectLocale() {
      return window.navigator.languages
        ? window.navigator.languages[0]
        : window.navigator.userLanguage || window.navigator.language
    },
    determineLocales() {
      if (['en', 'en-US', 'en-GB'].indexOf(this.detectLocale) != -1) {
        this.$i18n.locale = 'en'
        console.log('en')
      } else if (['pl', 'pl-PL'].indexOf(this.detectLocale) != -1) {
        this.$i18n.locale = 'pl'
        console.log('pl')
      }
    },
    addOnlineEventListener() {
      window.addEventListener('offline', this.updateOnlineStatus)
    },
    updateOnlineStatus() {
      this.$store.commit('addLogEntry', { message: 'offline', time: new Date() })
    }
  }
}
</script>

<template lang="pug">
#app
  remote-control-bar(v-if="this.$isRemoteClient && this.fingerprint && this.userToken")
  //- v-if="this.$isRemoteClient && this.fingerprint && this.userToken"

  router-view(name="header")
  router-view(name="content" :style="`margin-top:-${slideUp}vh`")
  router-view(name="navigation")
  toast-root
  modal-root
  root-socket-listener(v-if="!this.$isRemoteClient")
  version

  timeout-alert(v-if="timeoutAlertVisible && !this.$isRemoteClient")
  blocker(v-if="uiBlocked")
  remote-control-blocker(v-if="!this.$isRemoteClient")
  reconnect-blocker(v-if="uiBlockedByReconnect")
</template>

<style lang="scss">
@import './assets/styles/main.scss';

#app {
  position: relative;
  height: 100vh;
  display: flex;
  flex-direction: column;
}
</style>
